import {forwardRef, useImperativeHandle, useState} from 'react'

const style = {
  menu: {
    position: 'absolute',
    inset: '0px auto auto 0px',
    margin: 0,
    transform: 'translate(0px, 40px)'
  },
  menuRight: {
    position: 'absolute',
    inset: 'auth 0px 0px auto',
    margin: 0,
    transform: 'translate(0px, 40px)'
  },
  wrapper: {
    position: 'relative'
  }
}

export const Dropdown = forwardRef((props, ref) => {
  const {className, right} = props

  const [visible, setVisible] = useState(false)

  useImperativeHandle(ref, () => ({
    toggle() {
      setVisible(!visible)
    }
  }))

  return (
    <div style={style.wrapper}>
      <div
        className={`dropdown-menu ${className} ${visible ? 'show' : ''}`}
        style={visible ? (right ? style.menuRight : style.menu) : {}}
      >
        {props.children}
      </div>
    </div>
  )
})
